function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BFBBB7",
  fillRule: "nonzero",
  d: "M15.595.154a.525.525 0 0 0-.744 0L10.795 4.22H1.596c-.87 0-1.578.71-1.578 1.582v7.382c0 .873.708 1.582 1.578 1.582h.562v2.708a.527.527 0 0 0 .902.368l3.003-3.076h6.13c.87 0 1.579-.71 1.579-1.582V7.202l4.056-4.064a.528.528 0 0 0 0-.746L15.595.154zm-4.838 8.577L9.27 7.239l4.466-4.474 1.488 1.491-4.466 4.475zm-2.05-.562L9.83 9.293l-1.922.802.8-1.926zm4.012 5.014c0 .291-.236.528-.526.528h-6.35a.526.526 0 0 0-.377.158L3.21 16.18v-1.94a.527.527 0 0 0-.527-.528H1.596a.527.527 0 0 1-.526-.528V5.801c0-.291.236-.528.526-.528h8.146l-1.59 1.593a.539.539 0 0 0-.116.177l-1.457 3.504H3.737a.527.527 0 0 0 0 1.054H6.93c.068 0 .14-.014.207-.042l3.816-1.593a.534.534 0 0 0 .176-.116l1.59-1.593v4.926zm3.248-9.673L14.48 2.02l.744-.746 1.489 1.492-.745.745z"
});

var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback.6c16e4ae.svg";
export { ForwardRef as ReactComponent };